import _get from 'lodash/get'

export const getLocalState = (state) => state.renders
export const getEntries = (state) => _get(getLocalState(state), 'entries', {})
